import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {SenatorQualityGateService, SenatorService} from '../../../../../api/services';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {SenatorTrades} from '../../../../../api/models/senator-trades';
import {SenatorCompany} from '../../../../../api/models/senator-company';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {ShowTradeByIdComponent} from '../show-trade-by-id/show-trade-by-id.component';
import {SenatorAssetType} from '../../../../../api/models/senator-asset-type';
import {BestMatchIssuerMappingDialog} from '../best-match-issuer-mapping-dialog/best-match-issuer-mapping-dialog.component';
import {SenatorIssuerMappingsFilterModel} from '../../../../../api/models/senator-issuer-mappings-filter-model';
import {SenatorQualityGateType} from '../../../../../api/models/senator-quality-gate-type';
import {SenatorQualityGateModel} from '../../../../../api/models/senator-quality-gate-model';
import {SenatorAllCompanyMatching} from '../../../../../api/models/senator-all-company-matching';
import GetReplaceableAssetNamesParams = SenatorQualityGateService.GetReplaceableAssetNamesParams;

@Component({
  selector: 'app-all-companies-matching-mapping',
  templateUrl: './all-companies-matching-mapping.component.html',
  styleUrls: ['./all-companies-matching-mapping.component.scss']
})
export class AllCompaniesMatchingMappingComponent implements OnInit, AfterViewInit {

  @ViewChild(ShowTradeByIdComponent)
  showTradeById: ShowTradeByIdComponent;

  @ViewChild(BestMatchIssuerMappingDialog)
  bestMatchIssuerMappingDialog: BestMatchIssuerMappingDialog;

  twoIQAssetsList: SenatorCompany[] = [];
  issuerIndex: number;

  // mat table vars
  displayedColumns: string[] = ['count', 'trade', 'nameAssigned', 'gvkey', 'assetType', 'transactionType', 'tradeIndex', 'transactionDate', 'actionsSearchMaching'];
  issuerTableDataSource: MatTableDataSource<SenatorAllCompanyMatching>;

  pageSize: number;
  pageNumber: number;
  pageSizeOptions: number[] = [10, 20, 50];
  pageEvent: PageEvent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  issuerForm: FormGroup;
  lastPageNumber: number;

  loadingData: boolean;
  assetNamesLoading: boolean;
  selectedShareType = [] as string[];

  transactionTypes = ['Exchange', 'Purchase', 'Received', 'Sale', 'Sale (Full)', 'Sale (Partial)'];
  selectedTransactionType = [] as string[];

  shareTypes = SenatorAssetType.values().map(t => t.toString());
  loading = true;

  constructor(private qualityGateService: SenatorQualityGateService,
              private _senatorService: SenatorService, private senatorService: SenatorService,
              public snackBar: MatSnackBar, private _fb: FormBuilder, private changeDetectorRefs: ChangeDetectorRef) {
  }

  get _issuerFormArray(): FormArray {
    return this.issuerForm.get('issuers') as FormArray;
  }

  ngOnInit() {
    this.initVars();
    this.getAllCompaniesMatchingList();
  }

  ngAfterViewInit() {
    if (this.issuerTableDataSource) {
      this.issuerTableDataSource.paginator = this.paginator;
      this.issuerTableDataSource.sort = this.sort;
    }
  }

  initVars() {
    this.pageSize = 10;
    this.pageNumber = 1;
    this.assetNamesLoading = false;
    this.lastPageNumber = 0;
  }

  getAllCompaniesMatchingList() {
  /*  this.loadingData = true;

    const filterModel: SenatorIssuerMappingsFilterModel = {
      transactionTypes: this.selectedTransactionType,
      senatorAssetTypes: SenatorAssetType.values()
        .filter(type => this.selectedShareType.find(t => t == type.toString()) != null),
      qualityGateType: SenatorQualityGateType.ALL_COMPANIES_MATCHING,
      processedType: 'ALL'
    };

    const params: GetReplaceableAssetNamesParams = {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      issuerMappingsFilterModel: filterModel
    };
    this.loading = true;
    this.qualityGateService.getReplaceableAssetNames(params).subscribe(
      (res: SenatorQualityGateModel) => {
        this.issuerTableDataSource = new MatTableDataSource<SenatorAllCompanyMatching>(res.rowsForAllCompanyMatching);
        console.log('all matching:', res.rowsForAllCompanyMatching);

      },
      error => {
        this.loadingData = false;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.loadingData = false;
        if (this.paginator != null) {
          this.paginator.pageIndex = this.pageNumber - 1;
          this.paginator.pageSize = this.pageSize;
        }
      }
    );*/
  }

  searchAssetNames(companyName: string, trade: SenatorTrades) {
    this.assetNamesLoading = true;
    // console.log('Key up event', name);
    this._senatorService.getSenatorAssetNames(companyName).subscribe((res: SenatorCompany[]) => {
      this.twoIQAssetsList = res;
    }, (err) => {
      this.assetNamesLoading = false;
      // console.log('file update Error', err);
      if (err.status === 400 || err.status === 500) {
        this.openSnackBar('Something went wrong! please enter a valid company name.', 'Close');
      } else {
        this.openSnackBar(err.error.message, 'Close');
      }

    }, () => {
      this.assetNamesLoading = false;
      if (this.twoIQAssetsList.length === 0) {

        this.snackBar.open('No Company found with this name', 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
      }
    });
  }

  openSnackBar(message: string, action: string
  ) {
    this.snackBar.open(message, action, {
      duration: 5000,
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    });
  }

  onPaginateChange(event: PageEvent) {
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getAllCompaniesMatchingList();
    console.log('onPaginateChange: event', event);
  }

  openTrade(trade_id: number, type: string) {
    this.showTradeById.loadDialog(trade_id, type == 'R' ? 'Representative' : 'Senator');
  }

  tradeClosedEvent() {
    this.getAllCompaniesMatchingList();
  }

  onFindMatching(selectedRow: SenatorAllCompanyMatching) {
    this.bestMatchIssuerMappingDialog.loadDialog(selectedRow);
  }
}
